import { CITIES, CITY_SEO } from "../mock";

export const SERVICE_SLUGS = {
  "nanny": { id: "nanny", label: "Nanny", plural: "Nannies", icon: "Baby",
    angle: "full-time, part-time and live-in childcare" },
  "babysitter": { id: "babysitter", label: "Babysitter", plural: "Babysitters", icon: "Clock",
    angle: "occasional, evening and weekend babysitting" },
  "housekeeper": { id: "housekeeper", label: "Housekeeper", plural: "Housekeepers", icon: "Sparkles",
    angle: "regular, one-time and deep cleaning" },
  "senior-care": { id: "senior", label: "Senior care", plural: "Senior caregivers", icon: "HeartHandshake",
    angle: "compassionate daily companionship and support" },
};

const SERVICE_ORDER = ["senior-care", "babysitter", "housekeeper", "nanny"];

export function parseLanding(slug) {
  if (!slug) return null;
  for (const s of SERVICE_ORDER) {
    if (slug.startsWith(s + "-")) {
      const citySlug = slug.slice(s.length + 1);
      const city = CITIES.find((c) => c.slug === citySlug);
      if (city) return { serviceSlug: s, service: SERVICE_SLUGS[s], city, seo: CITY_SEO[citySlug] };
    }
  }
  return null;
}

export function landingSlug(serviceSlug, citySlug) {
  return `${serviceSlug}-${citySlug}`;
}

export function serviceRate(serviceId, citySlug) {
  const seo = CITY_SEO[citySlug];
  let base = 24;
  if (seo && seo.stats && seo.stats.avgRate) {
    const m = String(seo.stats.avgRate).match(/\d+/);
    if (m) base = parseInt(m[0], 10);
  }
  const FACTOR = { nanny: 1.0, babysitter: 0.82, housekeeper: 0.9, senior: 0.92 };
  const f = FACTOR[serviceId] != null ? FACTOR[serviceId] : 1;
  const low = Math.round((base * f * 0.9) / 1) ;
  const high = Math.round(base * f * 1.15);
  return `$${low}–$${high}/hr`;
}

export const ALL_LANDINGS = [];
for (const s of Object.keys(SERVICE_SLUGS)) {
  for (const c of CITIES) {
    ALL_LANDINGS.push({ serviceSlug: s, service: SERVICE_SLUGS[s], city: c, slug: `${s}-${c.slug}` });
  }
}
